var React = require('react');

function IconEllipsisFilled (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"4","cy":"12","r":"2","fill":"currentColor","key":0}),React.createElement("circle",{"cx":"12","cy":"12","r":"2","fill":"currentColor","key":1}),React.createElement("circle",{"cx":"20","cy":"12","r":"2","fill":"currentColor","key":2})]);
}

IconEllipsisFilled.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = IconEllipsisFilled;

IconEllipsisFilled.default = IconEllipsisFilled;
